import { Component, defineComponent } from '@decify/cell-shopify/client';
import './SearchBar.scss';
export const searchBarName = 'SearchBar';
export const searchBarTagName = 'cell-component-search-bar';
export const searchBarFocusEvent = 'focus';
export class SearchBar extends Component {
    elements;
    constructor() {
        super(searchBarName);
        const inputElement = this.querySelector('input');
        if (!inputElement) {
            throw new Error('Input element not found');
        }
        this.elements = {
            input: inputElement,
        };
        this.handleInputFocus = this.handleInputFocus.bind(this);
    }
    componentDidMount() {
        this.elements.input.subscribe('focus', this.handleInputFocus);
    }
    handleInputFocus() {
        this.publish(searchBarFocusEvent);
    }
}
defineComponent(searchBarTagName, SearchBar);
